import './grnFormat.css';
import React, { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, GET_GRN_LIST, BULK_APPROVE_GRN, GET_USER_DETAILS } from '../../../common/URLs';
import jwt from 'jwt-decode';

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Moment from 'moment';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { CommonInnerSidebar } from '../../../common/common-inner-sidebar/commonInnerSidebar';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PRINT_DOWNLOAD_DATA } from '../../../common/URLs';
import { PROD, PIT_ROLES } from '../../../common/constants';
import { DialogContent, Dialog, DialogActions, Box } from '@mui/material';
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { toast } from 'react-toastify';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { Fab, Typography, Button, Grid, Stack, Divider, CardContent, Card, Container } from '@mui/material';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { useTranslation } from 'react-i18next';
import apiClient from '../../../axios';
import { stakeholderType } from '../../../common/spinLoader';

export function GrnFormat() {
  const { t } = useTranslation();
  const decoded = jwt(getLocalStorageItem('id_token'));
  const navigate = useNavigate();
  const [accountName, setAccountName] = useState();
  const grnDetails = useLocation().state.selectedRow;
  const grnNumber = grnDetails?.grnNo ? grnDetails?.grnNo : grnDetails?.pitGrnSesNumber;
  const stakeHolderType = grnDetails?.deliveryStakeholderType ? grnDetails?.deliveryStakeholderType : null;
  const [grnListData, setGrnListData] = useState();
  const [downloadGrn, setDownloadGrn] = useState();
  const [grnList, setgrnList] = useState([]);
  const [bulkApproveGrn, setBulkApproveGrn] = useState();
  const handleLogModalOpen = () => setLogModalOpen(true);
  const [logModalOpen, setLogModalOpen] = useState(false);
  const [logModalOpen2, setLogModalOpen2] = useState(false);
  const handleLogModalOpen2 = () => setLogModalOpen2(true);
  const handleLogModalClose2 = () => { setLogModalOpen2(false); getGrnDetails(); }

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);
  const { state } = useLocation();
  const tabValue = useLocation().state.tabValue;
  const pageName = useLocation().state.pageName;
  const stakeholderType = useLocation().state.stakeholderType;

    const goBack = () => {
        if (state?.screen === "invoicePayment" || state?.screen === "invoice" || state?.pageName === "invoicePayment") {
            navigate('/paymentDashboard/invoicePayment', {
              state: { 
                tabValue: state?.tabValue, 
                stakeholderType: state?.stakeholderType ,
                openGroupId: state?.openGroupId
              }
            });
          }
          else if (state?.pageName === 'grnList') {
             navigate('/grnList', {
              state: { 
                tabValue: state?.tabValue, 
              }
            });
          }
          else if (state?.pageName === 'grnApprove') {
            navigate('/grnApprove', { state: {tabValue: state?.tabValue, materialTabValue: state?.materialTabValue}})
          }
        else {
            navigate(-1);
        }
    }

  useEffect(() => {
    getUserDetails();
  }, []);

  function getUserDetails() {
    apiClient
      .post(GET_USER_DETAILS,
        {
          "emailAddress": localStorage.getItem('InspectorEmail')
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setAccountName(response.data.user.firstname + " " + response.data.user.middlename + " " + response.data.user.lastname)
      })
      .catch(function (error) {
        console.log(error);
      });
  }



  useEffect(() => {
    getGrnDetails();
  }, []);


  const getGrnDetails = () => {
    loaderService.showLoader()
    apiClient
      .post(
        GET_GRN_LIST,
        {
          "grnNo": grnNumber,
          "stakeholderType": stakeHolderType,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        },
        null
      )
      .then((response) => {
        setGrnListData(response.data.grnList[0]);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  const getDownloadgrn = (action) => {

    loaderService.showLoader();
    apiClient
      .post(PRINT_DOWNLOAD_DATA,
        {
          "printDataByNumber": grnNumber,
          "printDetailsType": "grn"
        },
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

            Accept: 'application/pdf'
          }
        }, null
      )
      .then((response) => {
        setDownloadGrn(response.data);
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        if (action === "download") {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Output.pdf`
          );
          document.body.appendChild(link);

          link.click();
          link.parentNode.removeChild(link);
        }
        if (action === "print") {
          let iframe = document.createElement('iframe');
          document.body.appendChild(iframe);
          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }
        loaderService.hideLoader();
      }).catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onConfirmApprove = (e) => {
    handleConfirmClose();
    onApprove(e);
  }

  const onApproveButtonClick = (e) => {
    handleConfirmOpen();
  }

  const onApprove = (e) => {
    toApproveBulk(e);
  }

  const toApproveBulk = (e) => {
    loaderService.showLoader();
    apiClient
      .post(BULK_APPROVE_GRN,
        {
          "grnNoList": [grnListData?.grnNo],
          "approvedBy": accountName
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setBulkApproveGrn(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  useEffect(() => {
    if (bulkApproveGrn) {
      if (bulkApproveGrn.isSuccess === true) {
        toast.success(bulkApproveGrn?.message)
        // handleLogModalOpen2();
      }
      else {
        toast.error(bulkApproveGrn?.message ? bulkApproveGrn?.message : "Error")
        // handleLogModalOpen();
      }
    }
  }, [bulkApproveGrn]);

  const vendorCol = [
    {
      field: 'stakeholderSourceName', headerName: t('preReg.name'), width: 150,
    },
    { field: 'stakeholderSourceUrn', headerName: "URN", width: 180 },
    { field: 'poNo', headerName: "PO/STO No.", width: 180 },
    { field: 'stakeholderSourceContactName', headerName: "Contact Person", width: 180 },
    { field: 'stakeholderSourceContactNo', headerName: "Phone Number", width: 180 },
    { field: 'stakeholderSourceAddress', headerName: "Address", width: 180 },
    { field: 'stakeholderSourceGSTIN', headerName: "GSTIN", width: 180 },
  ]

  const columns = [
    {
      field: 'no', headerName: 'Line No.', width: 100,
      valueFormatter: () => "1"
    },
    { field: 'itemCode', headerName: 'Item Code', width: 100 },
    {
      field: 'itemDescription', headerName: 'Item Desc/HSN Code', width: 160,
      // valueFormatter: () => "Item Desc"
    },
    { field: 'pickupTotalWeight', headerName: 'Total Weight Picked Up', width: 180 },
    {
      field: 'destinationTotalWeight', headerName: 'Total Weight Received', width: 160,
    },
    {
      field: 'uom', headerName: 'UOM', width: 80,
      // valueFormatter: () => "MT"
    },
    {
      field: 'scheduledDeliveryDate', headerName: 'Scheduled Delivery Date', width: 180,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    {
      field: 'actualDeliveryDate', headerName: 'Actual Delivery Date', width: 160,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'receivedAndCheckedByName', headerName: 'Received By (Name)', width: 160 },
    // { field: 'receivedAndCheckedByName', headerName: 'Checked By (Name)', width: 160 },
    { field: 'comments', headerName: t('reg.comments'), width: 180 },
  ];


  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT28</p>}
        <Typography variant="h4" sx={{ mb: 2 }}>
                  <Fab onClick={() => { goBack() }} size="small" aria-label="back" title='Back'>
            <KeyboardArrowLeftRounded />
          </Fab> GRN Format
        </Typography>
        <Card>
          <CardContent>
            <Grid container direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2} divider={<Divider orientation="vertical" flexItem />}>
              <Grid item xs={12} lg={6} direction="column">
                {/* <Typography variant="subtitle1" gutterBottom>GRN Details</Typography> */}
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>GRN Number : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.grnNo}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>GRN Date : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {moment(grnListData?.grnDate).format("DD/MM/YYYY")}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Consignment Number : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.consignmentNo}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Invoice Number : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.grnPoDetailsList[0]?.invoiceNo}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Approved By : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.approvedBy}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} lg={6} direction="column">
                <Typography variant="subtitle1" gutterBottom>Delivery Location Details</Typography>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Name : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.deliveryStakeholderName}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>URN : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.deliveryStakeholderUrn}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Contact Person : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.deliveryStakeholderContactName}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Phone Number : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.deliveryStakeholderContactNo}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Address : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.deliveryStakeholderAddress}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>GSTIN : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.deliveryStakeholderGSTIN}
                  </Typography>
                </Stack>
                {/* <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Place of Supply : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>

                  </Typography>
                </Stack> */}
              </Grid>
            </Grid>
            <Grid container direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2} divider={<Divider orientation="vertical" flexItem />}>
              <Grid item xs={12} lg={6} direction="column">
                <Typography variant="subtitle1" gutterBottom>Customer Details</Typography>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Name : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.customerStakeholderName}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>URN : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.customerStakeholderUrn}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Contact Person : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.customerStakeholderContactName}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Phone Number : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.customerStakeholderContactNo}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Address : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.customerStakeholderAddress}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>GSTIN : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.customerStakeholderGSTIN}
                  </Typography>
                </Stack>

              </Grid>
              <Grid item xs={12} lg={6} direction="column">
                <Typography variant="subtitle1" gutterBottom>Shipping Details</Typography>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Shipped By (Name) : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.shippedByName}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Shipped By (Phone) : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {grnListData?.shippedByPhone}
                  </Typography>
                </Stack>
                {/* <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>Shipping Date : </Typography>
                <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                  {moment(grnListData?.shippingDate).format('DD/MM/YYYY')}
                </Typography>
              </Stack> */}
              </Grid>
            </Grid>
            <Grid container spacing={1} direction={{ xs: 'column', sm: 'row' }}>
              <Grid item xs={12} lg={12} direction="column">
                <Typography style={{ marginTop: "4vh" }} variant="subtitle1" gutterBottom>Vendor Details</Typography>
                {grnListData?.grnPoDetailsList &&
                  <DataGrid
                    autoHeight
                    rows={grnListData?.grnPoDetailsList}
                    columns={vendorCol}
                    getRowId={(row) => row?.invoiceNo}
                    hideFooterPagination

                  />
                }

              </Grid>
            </Grid>
            {
              grnListData &&
              <DataGrid style={{ marginTop: "4vh" }}
                autoHeight
                rows={grnListData ? [grnListData] : []}
                getRowId={(row) => row?.id}
                columns={columns}
                hideFooterPagination

              />
            }


          </CardContent>
        </Card>
        <Box display='flex' justifyContent="flex-end" mt={2}>
          {grnListData?.isApproved === false && localStorage.getItem('role') == PIT_ROLES.ProcessingIncharge ?
            <Button variant="contained" onClick={(e) => onApproveButtonClick(e)}>Approve</Button>
            : null
          }
          <Button variant="contained" sx={{ ml: 2 }} onClick={() => getDownloadgrn("download")}>Download</Button>
          <Button variant="contained" sx={{ ml: 2 }} onClick={() => getDownloadgrn("print")}>Print</Button>
        </Box>
      </Container>
      <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Approve" />
      <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
        <DialogContent>
          <ConfirmPopover title={bulkApproveGrn?.message ? bulkApproveGrn?.message : "Error"} hideLink={true} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose2}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
export default GrnFormat;